export const defaultVisitors = {
    Visitors0: 0,
    Visitors1: 0,
    Visitors2: 0,
    Visitors3: 0,
    Visitors4: 0,
    Visitors5: 0,
    Visitors6: 0,
    Visitors7: 0,
    Visitors8: 0,
};
